import React from 'react';
import { Home, Compass, Plus, ClipboardList, MessageSquare } from 'lucide-react';

const ADD_BG = '#0F4C4A';

// Five slots, with "+" raised in the middle.
//
// Scan used to hold this slot. It moved to the top bar — still one tap from
// anywhere — because scanning happens a handful of times a month, whereas the
// thing the app now wants a member to do every day is log something. The centre
// slot is the most valuable real estate on the screen, so it belongs to the
// daily habit rather than the occasional one.
export const NAV_ITEMS = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'moments', label: 'Moments', icon: Compass },
  { id: 'add', label: 'Add', icon: Plus, isAdd: true },
  { id: 'activity', label: 'Activity', icon: ClipboardList },
  { id: 'messages', label: 'Messages', icon: MessageSquare }
];

export default function BottomNav({ activeTab, onNavigate, messageCount = 0 }) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-border/60 bottom-nav-shadow z-50"
      data-testid="bottom-nav"
    >
      <div className="desktop-shell">
        <div className="grid grid-cols-5 h-16">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;

            if (item.isAdd) {
              return (
                <button
                  key={item.id}
                  type="button"
                  data-testid="nav-add"
                  onClick={() => onNavigate(item.id)}
                  aria-label="Log or do something"
                  className="flex items-start justify-center"
                >
                  <span
                    className="-translate-y-4 h-14 w-14 rounded-full flex items-center justify-center text-white shadow-lg ring-4 ring-white transition-transform active:scale-95"
                    style={{ backgroundColor: ADD_BG }}
                  >
                    <Plus className="h-7 w-7" strokeWidth={2.4} />
                  </span>
                </button>
              );
            }

            return (
              <button
                key={item.id}
                type="button"
                data-testid={`nav-${item.id}`}
                onClick={() => onNavigate(item.id)}
                aria-current={isActive ? 'page' : undefined}
                className="flex flex-col items-center justify-center gap-1 relative group"
              >
                <span className="relative">
                  <Icon
                    className={`h-[22px] w-[22px] transition-colors ${
                      isActive ? 'text-primary' : 'text-muted-foreground group-hover:text-foreground'
                    }`}
                    strokeWidth={isActive ? 2.5 : 1.9}
                  />
                  {item.id === 'messages' && messageCount > 0 && (
                    <span
                      data-testid="nav-messages-count"
                      className="absolute -top-1.5 -right-2 min-w-[17px] h-[17px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center leading-none"
                    >
                      {messageCount}
                    </span>
                  )}
                </span>
                <span
                  className={`text-[11px] leading-none transition-colors ${
                    isActive ? 'font-bold text-primary' : 'font-medium text-muted-foreground'
                  }`}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
